import React, {lazy, Suspense} from "react";
import {Login} from "Pages/Login/Login";
import {ForgotPassword} from "Pages/Login/ForgotPassword";
import {ResetPassword} from "Pages/Login/ResetPassword";
import {PageNotFound} from "Pages/PageNotFound";
import {PublicAuditViewer} from "Pages/Audits/PublicAuditViewer";

const WelcomeVideo = lazy(() => import("Pages/WelcomeVideo").then((module) => ({default: module.WelcomeVideo})));
const Audits = lazy(() => import("Pages/Audits/Audits").then((module) => ({default: module.Audits})));
const AuditCreator = lazy(() => import("Pages/Audits/AuditCreator").then((module) => ({default: module.AuditCreator})));
const AuditViewer = lazy(() => import("Pages/Audits/AuditViewer").then((module) => ({default: module.AuditViewer})));
const AuditLogs = lazy(() => import("Pages/Audits/AuditLogs").then(
    (module) => ({default: module.AuditLogs}),
));

const Subscribers = lazy(() => import("Pages/Subscriber/Subscribers").then(
    (module) => ({default: module.Subscribers}),
));
const SubscriberSettings = lazy(() => import("Pages/Subscriber/SubscriberSettings").then(
    (module) => ({default: module.SubscriberSettings}),
));
const Accounts = lazy(() => import("Pages/Accounts/Accounts").then(
    (module) => ({default: module.Accounts}),
));
const Locations = lazy(() => import("Pages/Location/Locations").then(
    (module) => ({default: module.Locations}),
));
const Users = lazy(() => import("Pages/Users/Users").then(
    (module) => ({default: module.Users}),
));
const Reports = lazy(() => import("Pages/Reports/Reports").then(
    (module) => ({default: module.Reports}),
));

export const getPathElementMap = (setCurrentLoggedUser, resetCurrentUserSession) => [
    {path: "/welcome",
        element: <Suspense fallback={"loading..."}>
            <WelcomeVideo updateCurrentLoggedUser={setCurrentLoggedUser} />
        </Suspense>},
    {path: "/",
        element:
            <Suspense fallback={"loading..."}><Audits updateCurrentLoggedUser={setCurrentLoggedUser} /></Suspense>},
    {path: "/dashboard",
        element: <Suspense fallback={"loading..."}> <Audits updateCurrentLoggedUser={setCurrentLoggedUser} />
        </Suspense>},
    {path: "/audits",
        element: <Suspense fallback={"loading..."}> <Audits updateCurrentLoggedUser={setCurrentLoggedUser} />
        </Suspense>},
    {path: "/audits/:auditID",
        element: <Suspense fallback={"loading..."}> <AuditViewer /> </Suspense>},
    {path: "/audits/creator",
        element: <Suspense fallback={"loading..."}> <AuditCreator /> </Suspense>},
    {path: "/audits/logs/:auditID", element: <Suspense fallback={"loading..."}> <AuditLogs /> </Suspense>},
    {path: "/public-audits/:auditID", element: <PublicAuditViewer />},

    {path: "/subscribers/", element: <Suspense fallback={"loading..."}> <Subscribers /> </Suspense>},
    {path: "/subscriber_settings/", element: <Suspense fallback={"loading..."}> <SubscriberSettings /> </Suspense>},
    {path: "/accounts/", element: <Suspense fallback={"loading..."}> <Accounts /> </Suspense>},
    {path: "/locations/", element: <Suspense fallback={"loading..."}> <Locations /> </Suspense>},
    {path: "/reports/", element: <Suspense fallback={"loading..."}> <Reports /> </Suspense>},
    {path: "/users/", element: <Suspense fallback={"loading..."}> <Users /> </Suspense>},

    {path: "*", element: <PageNotFound />},
    {path: "/reset-password", element: <ResetPassword resetCurrentUserSession={resetCurrentUserSession} />},
];

export const getUnauthenticatedPathElementMap = (setHasValidRefreshToken) => [
    {path: "/login", element: <Login setHasValidRefreshToken={setHasValidRefreshToken} />},
    {path: "/forgot-password", element: <ForgotPassword />},
    {path: "/reset-password", element: <ResetPassword />},
    {path: "*", element: <Login setHasValidRefreshToken={setHasValidRefreshToken} />},
    {path: "/public-audits/:auditID", element: <PublicAuditViewer />},
];

export const unRedirectionPaths = [
    "/reset-password",
];
